var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.parsedButtons.length > 0
    ? _c(
        "v-menu",
        {
          attrs: {
            bottom: "",
            left: "",
            "nudge-bottom": "42",
            "nudge-right": "18",
            "content-class": "custom-context-menu",
          },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "button",
                      _vm._g(
                        _vm._b(
                          {
                            staticClass: "context-menu-kebab-btn",
                            on: { click: _setup.onKebabClick },
                          },
                          "button",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _c("span", {
                          staticClass: "lf-icon__lg",
                          class: _setup.kebabIcon,
                        }),
                      ]
                    ),
                  ]
                },
              },
            ],
            null,
            false,
            2515937796
          ),
        },
        [
          _c(
            "v-list",
            { staticClass: "context-menu-list" },
            _vm._l(
              _setup.parsedButtons,
              function ({ action, tooltip, icon, enabled }, i) {
                return _c("v-list-item", { key: i, staticClass: "list-item" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      attrs: { disabled: !enabled },
                      on: {
                        click: function ($event) {
                          return _setup.executeAction(action)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "lf-icon__lg", class: icon }),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(tooltip)),
                      ]),
                    ]
                  ),
                ])
              }
            ),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }